import * as React from 'react';
const SvgArrowDown = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 18, height: 18, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M4.826 6.7a.6.6 0 0 1 .848 0L9 10.028 12.326 6.7a.6.6 0 1 1 .848.848l-3.75 3.75a.6.6 0 0 1-.848 0l-3.75-3.75a.6.6 0 0 1 0-.848',
      clipRule: 'evenodd',
    }),
  );
export default SvgArrowDown;
